export const isStandalone = process.env.REACT_APP_STANDALONE === '1';

const inIframe = () =>
  isStandalone ||
  (window.parent && window.parent !== window) ||
  new URLSearchParams(window.location.search).get('embed') === '1';

const post = (payload) => {
  if (!inIframe()) return;
  window.parent.postMessage({ type: 'bonza-estimator', ...payload }, '*');
};

export const notifyParentScrollTop = () => post({ scrollTop: true });

export const goToThankYou = () => {
  if (isStandalone) {
    window.location.hash = '#/business-pricing-thank-you';
    window.location.reload();
    return;
  }
  window.location.href = '/business-pricing-thank-you';
};

export const startEmbedBridge = () => {
  if (!inIframe()) return () => {};
  document.documentElement.classList.add('bonza-embedded');
  if (window.parent === window) return () => {};
  const root = document.getElementById('root');
  const send = () => post({ height: root.scrollHeight });
  const observer = new ResizeObserver(send);
  observer.observe(root);
  window.addEventListener('load', send);
  send();
  return () => observer.disconnect();
};
